<ng-template #template let-total>
    {{totalLabel(total) | async}}
    <!-- {{translate("Total")}} {{ total }} <ng-container *ngIf="is"></ng-container> -->
</ng-template>